import React, {FC} from "react"
import {Row, Col} from "react-bootstrap"
import {withTheme, WithDefaultTheme} from "styled-components"

import Icon, {IconTypes} from "@irati/ui/src/Icon"
import FormattedMessage from "@irati/utils/lang"
import {Label} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"

interface Props extends WithDefaultTheme {
  isFavouriteDeal?: boolean
}

const UnavailableDeal: FC<Props> = ({isFavouriteDeal, theme}) => {
  return (
    <Flex
      justifyContent={isFavouriteDeal ? "center" : "flex-start"}
      alignItems={isFavouriteDeal ? "center" : "stretch"}
      minHeight={theme.spacing.eight}>
      {isFavouriteDeal && (
        <Label large>
          <FormattedMessage id="perks.components.dealBody.unavailableDeal.header" />
        </Label>
      )}
      {!isFavouriteDeal && (
        <Row>
          <Col xs={12}>
            <Flex alignItems="center">
              <Icon icon={IconTypes.circleDisable} size={25} color={theme.colors.utility.ink} />
              <Label large weight="bold" marginLeft>
                <FormattedMessage id="perks.components.dealBody.unavailableDeal.header" />
              </Label>
            </Flex>
          </Col>
        </Row>
      )}
    </Flex>
  )
}

export default withTheme(UnavailableDeal)
